import React from 'react';

import { LEFT, RIGHT, BACK, ENTER } from '../util/remoteButtons';
import { fireAnalytics } from './utils';


export class Error extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.selectedBtn = 'No';
  }

  componentDidMount() {
    fireAnalytics('Page', 'Error Page Loaded');
    clearInterval(this.onlineStatusInterval);
    setTimeout(() => {
      window.open("", "_self").close();
    }, 60000);
    window.onkeydown = (e) => {
      switch (e.which) {
        case RIGHT:
          if (this.state.open) {
            document.getElementById('No').style.background = '';
            document.getElementById('yes').style.background =
              '#910048';
            this.refs.yes.focus();
            this.selectedBtn = 'Yes';
          }
          break;
        case LEFT:
          if (this.state.open) {
            document.getElementById('yes').style.background = '';
            document.getElementById('No').style.background =
              '#910048';
            this.refs.no.focus();
            this.selectedBtn = 'No';
          }
          break;
        case ENTER:
          if (this.state.open) {
            if (this.selectedBtn === 'No') {
              this.setState({ open: false });
              setTimeout(() => {
                const { mainDiv } = this.refs;
                mainDiv.focus();
              }, 700);
            }
          }
          if (this.selectedBtn === 'Yes') {
            window.open("", "_self").close();
          }
          break;
        case 27: // ///////////////For Esc Keyboard Key
        case BACK:
          setTimeout(() => {
            const { no } = this.refs;
            no.focus();
          }, 700);
          this.setState({ open: !this.state.open });
          break;
      }
    };
  }

  render() {
    return (
      <div className="Wrapper">
        {
          this.state.open ? (
            <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
              <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                <img className="Logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
                <button
                  ref="no"
                  id="No"
                  onClick={() => {
                    this.setState({ open: false });
                  }}
                  style={{ background: '#910048' }}
                  className="exitPopup"
                >No
                </button>
                <button
                  ref="yes"
                  id="yes"
                  style={{ marginLeft: '2%' }}
                  className="exitPopup"
                >Yes
                </button>
              </div>
            </div>
          ) : null
        }
        <div className="ErrorWrapper">
          <img className="ErrorLogo" src="/assets/img/blackdove-logo-2020.png" alt="" />
          <span className="ErrorInfo">
            Network Interruption Detected
            <br />
            To Exit the app, press RETURN/BACK Key on Remote Controller and select 'YES'.
            <br />
            Else, the app will EXIT automatically after 60 seconds.
            <br />
            OR
            <br />
            To Launch the app again, press OK key on Remote Controller.
          </span>
        </div>
      </div>
    );
  }
}

export default Error;
